<template lang="pug">
  div
    section.header
      h2 1. Seleccione el local
      p
        span Por favor seleccione el local en el que se encuentra y desea hacer la reclamación
      hr

    transition-group.contenedor-transition(name="fade-smooth", tag="div")
      .select-box(key="select-box")
        .option.bd-color-empresa(
          v-for="o in locales"
          :class="{ 'bg-empresa': o.codigo === local.codigo }"
          @click="seleccionar(o)"
        )
          span.descripcion {{ o.descripcion }}
      .description-box.message.is-info(
        v-if="local && local.codigo"
        key="description-box"
      )
        div.message-body
          div
            strong RUC
            span.value : {{ empresa.ruc }}
          div
            strong Razon social
            span.value : {{ empresa.razonSocial }}
          div
            strong Dirección del local
            span.value : {{ local.direccion }}
</template>

<script>
import { apiGet, notify } from '../util/general'
export default {
  name: 'box-seleccionar-local',
  data () {
    return {
      empresa   : {},
      locales   : [],
      local     : {},
      isLoading : true
    }
  },
  created () {
    this.fetch();
  },
  methods: {
    seleccionar (o) {
      this.local = o
      this.$emit('selected', this.local)
    },
    fetch () {
      let vm = this

      var obj = {}
      apiGet(vm, '/libroreclamaciones/local', obj, function (data) {
        vm.isLoading = false
        console.log('data:', data)
        vm.empresa.ruc         = data.empresa.ruc
        vm.empresa.razonSocial = data.empresa.razonSocial
        vm.locales             = data.lista
      }, function (error) {
        console.log(error);
        vm.isLoading = false
        notify(vm, 'error', 'Error', 'Problemas al obtener locales')
      })
    },
    clean () {
      this.local = {}
    }
  }
}
</script>
<style lang="stylus">
  //Select box, las que se pintan de rojo
  .select-box
    display flex
    .option
      cursor pointer
      border 3px solid #ccc
      flex 1
      margin 10px
      display flex
      flex-direction column
      align-items center
      padding 5px
      transition all ease 0.3s
      border-radius 5px
      &:hover
        background-color #eae8e8
      .codigo
        font-size 13px
        color #bebebe
      .descripcion
        font-size 17px
        font-weight bold
  
  .description-box
    margin-top 5px
    strong
      min-width 150px
      display: inline-block;
</style>



// WEBPACK FOOTER //
// Box-1-seleccionar-local.vue?64a38b06